import { Reservation } from "@workspace/domain/src/features/reservation";
import { t } from "i18next";
import * as z from "zod";

export const RESERVATION_STATUS_OPTIONS = [
  {
    value: "PAYMENT_PENDING",
    label: t("reservations.status.PAYMENT_PENDING"),
  },
  {
    value: "PAYMENT_PARTIAL",
    label: t("reservations.status.PAYMENT_PARTIAL"),
  },
  {
    value: "PAYMENT_RESERVATION",
    label: t("reservations.status.PAYMENT_RESERVATION"),
  },
  {
    value: "PAYMENT_COMPLETE",
    label: t("reservations.status.PAYMENT_COMPLETE"),
  },
  {
    value: "OVERPAID",
    label: t("reservations.status.OVERPAID"),
  },
  {
    value: "REFUND_PENDING",
    label: t("reservations.status.REFUND_PENDING"),
  },
  {
    value: "REFUND_PARTIAL",
    label: t("reservations.status.REFUND_PARTIAL"),
  },
  {
    value: "REFUND_COMPLETE",
    label: t("reservations.status.REFUND_COMPLETE"),
  },
  {
    value: "OVERREFUNDED",
    label: t("reservations.status.OVERREFUNDED"),
  },
  {
    value: "NO_REFUND",
    label: t("reservations.status.NO_REFUND"),
  },
] as const satisfies {
  value: Reservation["Status"][number];
  label: string;
}[];

export function getReservationStatusColor(status: Reservation["Status"][number]) {
  switch (status) {
    case "PAYMENT_PENDING":
      return "orange";
    case "PAYMENT_PARTIAL":
      return "blue";
    case "PAYMENT_RESERVATION":
      return "green";
    case "PAYMENT_COMPLETE":
      return "green";
    case "OVERPAID":
      return "red";
    case "REFUND_PENDING":
      return "yellow";
    case "REFUND_PARTIAL":
      return "blue";
    case "REFUND_COMPLETE":
      return "green";
    case "OVERREFUNDED":
      return "red";
    case "NO_REFUND":
      return "red";
    default:
      return "gray";
  }
}

export const ReservationFiltersSchema = z.object({
  reservationStatus: z.enum(Reservation["Status"]).optional(),
  reservationSearch: z.string().optional(),
});
export type ReservationFiltersSchema = z.infer<typeof ReservationFiltersSchema>;
